import { render } from "./SettingsIndex.vue?vue&type=template&id=17e9709e"
import script from "./SettingsIndex.vue?vue&type=script&lang=js"
export * from "./SettingsIndex.vue?vue&type=script&lang=js"

import "./SettingsIndex.vue?vue&type=style&index=0&id=17e9709e&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__